export default __webpack_public_path__ + "static/media/sage_green.c78e26a7.jpeg";